(function() {
	'use strict';

	angular.module('quantixApp').factory('CompanyProfileService',
			CompanyProfileService);

	CompanyProfileService.$inject = [ '$resource', '$http', '$q' ];

	function CompanyProfileService($resource, $http, $q) {

		var _getCompanyDetails = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyDetails';
			var data = {
				companyCode : companyCode
			};

			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		// Service for companies By Category
		var _getCompaniesByCategory = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompaniesByCategory';
			var data = {
				companyCode : companyCode
			};

			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		// Service for companies for recentlyandMostlyViewed
		var _getRecentlyViewAndMostView = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getRecentlyViewAndMostView';
			var data = {
				companyCode : companyCode
			};

			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		// service for financial data
		var _getFinancialCompanyList = function(companyCode) {
			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};
			var url = 'api/companyProfile/getFinancialCompanyList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		// service for peer comparison
		var _getPeerComparisonCompanyList = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPeerComparisonCompanyList';
			var data = {
				companyCode : companyCode
			};
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		// service for score company list
		var _getCompanyScoreList = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyScoreList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanyLongTermRatingList = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyLongTermRatingList';
			var data = {
				companyCode : companyCode
			};
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanyLongTermUnacceptedRatingList = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyLongTermUnacceptedRatingList';
			var data = {
				companyCode : companyCode
			};
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getAllRatingAgency = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getAllratingAgency';

			$http.post(url).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanyShortTermRatingList = function(companyCode) {
			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};
			var url = 'api/companyProfile/getCompanyShortTermRatingList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanySecurityDetailList = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanySecurityDetailList';
			var data = {
				companyCode : companyCode
			};
			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanyBenchMarksList = function(matrix) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyBenchMarksList';
			var data = {
				matrix : matrix
			};
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		// starting misc info data..................................

		var _getMiscInfoCompanyList = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getMiscInfoCompanyList';
			var data = {
				companyCode : companyCode
			};
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		// Ending misc info data........................

		// ending capitalMarketing..............
		var _getCompanyKeyParameterDetails = function(companyCode) {

			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};

			var url = 'api/companyProfile/getCompanyKeyParameterDetails';

			$http.post(url, data).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _getBseSharePriceData = function(companyCode) {

			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};

			var url = 'api/companyProfile/getBseSharePricedata';

			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _getCompanyFixedIncomeData = function(companyCode) {

			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};

			var url = 'api/companyProfile/getFixedIncomedata';

			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		// statring CapitalMarketing................

		var _getCapitalMarketInformation = function(companyCode,
				selectedIndices) {
			var deferred = $q.defer();
			var data = {
				companyCode : companyCode,
				indices : selectedIndices
			};
			var url = 'api/companyProfile/getCapitalMarketInformation';
			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		//MGTshareHolding
		
		var _getMGTShareHoldingData = function(companyCode) {
			var deferred = $q.defer();
		
			var url = 'api/companyProfile/getMGTShareHoldingPatternData';
			$http.post(url, companyCode, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		// service for RatingSummary
		var _getRatingSummary = function(companyCode) {
			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};
			var url = 'api/companyProfile/getRatingSummary';
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		// service for UnacceptedRatingSummary
		var _getUnacceptedRatingSummary = function(companyCode) {
			var deferred = $q.defer();
			var data = {
				companyCode : companyCode
			};
			var url = 'api/companyProfile/getUnacceptedRatingSummary';
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		// service for Show Document Of PDF Or HTML
		var _showDocumentOfPDFOrHTML = function(fileName, docType) {
			var deferred = $q.defer();
			var filePathURL = 'api/companyProfile/showDocumentOfPDFOrHTML';
			var fd = new FormData();
			fd.append('fileName', fileName);
			fd.append('docType', docType)
			$http.post(filePathURL, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				}
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		var _getSmeCompanyDetails = function(companyCode) {
			var data = {
				companyCode : companyCode
			};
			var deferred = $q.defer();
			var url = 'api/companyProfile/getSmeCompanyDetails';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanyPeerComparisonMoreData = function(companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyPeerComparisonMoreData';
			$http.post(url, companies).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getPeerRatingData = function(companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyPeerComparisonMoreForRating';
			$http.post(url, companies, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getPeerKeyIndicator = function(companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyPeerComparisonKeystockIndicator';
			$http.post(url, companies, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getPeerSharePricedata = function(companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyPeerComparisonMoreForSharePrice';
			$http.post(url, companies, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getPeerFinancialInformation = function(companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyPeerComparisonMoreForFinInfo';
			$http.post(url, companies, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getPeerKeyParamData = function(companies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPeerKeyParamdData';
			$http.post(url, companies, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getPeerSuggesionsList = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPeerSuggesionsList';
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _saveRecentlyViewedCompanyForCompanyProfileModule = function(
				companyCode, moduleFlag) {

			var recentlyViewedDTO = {
				moduleID : 6,
				companyCode : companyCode,
				moduleFlag : moduleFlag
			};
			return $http(
					{
						method : 'POST',
						url : 'api/companyProfile/saveRecentlyViewedCompanyForCompanyProfileModule',
						headers : {
							'Content-type' : 'application/json'
						},
						data : recentlyViewedDTO
					}).success(function(data) {
			}).error(function(data) {

			});
		}
		var _getCompaniesListByNameForPeerComparison = function(
				searchedCompany, companyName) {
			var data = {
				searchedCompany : searchedCompany,
				companyName : companyName
			};
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompaniesListByNameForPeerComparison';
			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getPeerFixedIncomeData = function(companyName) {

			var deferred = $q.defer();
			var url = 'api/companyProfile/peerFixedIncomeData';
			$http.post(url, companyName, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getBoardOfDirector = function(boardName) {
			var data = {
				directorName : boardName
			};
			var deferred = $q.defer();
			var url = 'api/companyProfile/getBoardOfDirector';
			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		// Service for portFolios list by user id
		var _getPortFolioNames = function(filterData) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getAllPortfolioNames';
			$http.post(url, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getNoOfCompanies = function(listOfCompanies) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getNoOfCompanies';
			$http.post(url, listOfCompanies).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}
		var _displayingPeerData = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPeerData';

			$http.post(url, data).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _downloadCompanyProfileScorecardExcel = function(parameterList) {

			var deferred = $q.defer();
			// var url ='api/masterData/fullImpCompQury';
			var url = 'api/companyProfile/generateCompanyProfileScorecardExcel';
			$http.post(url, parameterList, {
				responseType : 'arraybuffer',
			}).then(function(response) {

				deferred.resolve(response.data);

			}, function(response) {
				deferred.reject(response);

			});
			return deferred.promise;
		}
		var _getExportScorecardPdf = function(parameterList) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getExportScorecardPdf';
			$http.post(url, parameterList, {
				responseType : 'arraybuffer',
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(response) {
				deferred.reject(response);
			});
			return deferred.promise;
		}

		var _getIndustryMedian = function(companyCode) {

			var deferred = $q.defer();
			var url = 'api/companyProfile/getIndustryMedian';
			$http.post(url, {
				'companyCode' : companyCode
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getMappedIndicesForCompany = function(companyCode) {

			var deferred = $q.defer();
			var url = 'api/companyProfile/getMappedIndices';
			$http.post(url, {
				'companyCode' : companyCode
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getRecentUploadedFinancialCompanies = function(financialFlag) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getRecentUploadedFinancialCompanies';
			$http.post(url, financialFlag, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		// To Get Existing portfolios
		var _getExistingPortFoliosDetailsByUser = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getExistingUserPortFoliosDetailsByUser';
			var data = {
				companyCode : companyCode
			};

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _addCompanyInExistingPortfolio = function(portfolio) {

			var deferred = $q.defer();
			var url = 'api/portfolio/addCompanyInExistingUserPortfolio';

			$http.post(url, portfolio).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		// Service for portFolios list by user id
		var _getPortFoliosCompDetailsByUser = function(filterData) {
			var data = {
				filterData : filterData
			};
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPortFoliosCompDetailsByUser';
			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		
		var _getKeyMoreParamData = function(companyCode) {

			var deferred = $q.defer();
			var url = 'api/companyProfile/getKeyMoreParameterList';
			$http.post(url, companyCode, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		

		var _getIndustryBenchmarkFinancialDetails = function(companyCode) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyBenchmarkFinancialDetails';
			var data = {
				companyCode : companyCode
			};
			$http.post(url, data, {
				ignoreLoadingBar : true
			}).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getCompanyScoreCardDataList = function(data) {
			var deferred = $q.defer();
			var url = 'api/scoreCard/getCompanyScoreCardDataList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getPeerData = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPeerCompareCompanyList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getPeerInfoData = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getPeerInfoData';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getCompanyChargeIndexData = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/getCompanyChargeDataList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getBulkBlockDealList= function(companyCode,tabtype) {
			var deferred = $q.defer();
			var config={
					"params": {"companyCode":companyCode,"tabtype":tabtype}
				}
			
			var url = 'api/companyProfile/getBulkBlockDealList';

			$http.get(url, config).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getReportedFinancialsDetails= function(companyCode,tabtype) {
			var deferred = $q.defer();
			var config={
					"params": {"companyCode":companyCode,"tabtype":tabtype}
				}
			
			var url = 'api/companyProfile/getReportedFinancialsDetails';

			$http.get(url, config).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _getDirectorPromoterByNameList= function(searchText) { 
           var deferred = $q.defer();
			var url = 'api/companyProfile/getDirectorPromoterByNameList';
           $http.post(url, searchText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		
		}
		
		var _getBusinessActivityDetails= function(companyCode) {
			var deferred = $q.defer();
			var config={
					"params": {"companyCode":companyCode}
				}
			
			var url = 'api/companyProfile/getBusinessActivityDetails';

			$http.get(url, config).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getDetailedShareHoldingData = function(companyCode)
		{
			var deferred = $q.defer();

			var config={
				"params": {"companyCode":companyCode}
			}
			
			var url = 'api/companyProfile/getDetailedShareHoldingData';

			$http.get(url,config).then(function(response){
				deferred.resolve(response.data);
			},function(errResponse){
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getCorporateAction = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getCorporateActionData';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getAlertData = function(data)
		{
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getAlertData';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getCibilCase = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getCibilCase';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getNews = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getNewsData';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getcorporateaccounment = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getCorporateAccounment';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getcorporateaccounmentdatelist = function(data) {
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getCorporateAccounmentDateList';

			$http.post(url, data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getComitteeMeetingData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getComitteeMeeting';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getUboData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getUbo';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getComitteeMeetingPreviousData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getComitteeMeetingPrev';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getBoardAttendanceData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getBoardAttendance';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getBoardAttendancePreviousData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getBoardAttendancePrev';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getBoardMeetingData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getBoardMeeting';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getBoardMeetingPreviousData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getBoardMeetingPrev';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getManagementDisclosureData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getManagementDisclosure';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getManagementDisclosurePreviousData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getManagementDisclosurePrev';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		
		var _getRegulatoryDisclosure = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getRegulatoryDisclosure';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompoundingDisclosure = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getCompoundingDisclosure';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		

		var _getRegulatoryDisclosurePreviousData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getRegulatoryDisclosurePrev';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getCompoundingDisclosurePreviousData = function(data)
		{
			var deferred = $q.defer();
			var url = 'api/companyProfile/newDataPoint/getCompoundingDisclosurePrev';
			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _getEpfo = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getEpfoList';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getGst = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getGstList';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getPeriodGst = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getGstPeriodList';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getAlertData = function(data)
        {
            var deferred = $q.defer();
            // var config={
            //  "params": {"companyCode":companyCode}
            // }
            var url = 'api/companyProfile/newDataPoint/getAlertData';
            $http.post(url,data).then(function(response) {
                deferred.resolve(response.data);
            }, function(errResponse) {
                deferred.reject(errResponse);
            });
            return deferred.promise;
        }
		var _getExternalCommercialBorrowing = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getExternalCommercialBorrowing';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getOverseasDirectInvestment = function(data) {
			var deferred = $q.defer();
			// var config={
			// 	"params": {"companyCode":companyCode}
			// }
			var url = 'api/companyProfile/newDataPoint/getOverseasDirectInvestment';

			$http.post(url,data).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}



		return {
			getCompanyLongTermUnacceptedRatingList : _getCompanyLongTermUnacceptedRatingList,
			getUnacceptedRatingSummary : _getUnacceptedRatingSummary,
			getCompanyDetails : _getCompanyDetails,
			getCompaniesByCategory : _getCompaniesByCategory,
			getFinancialCompanyList : _getFinancialCompanyList,
			getPeerComparisonCompanyList : _getPeerComparisonCompanyList,
			getCompanyScoreList : _getCompanyScoreList,
			getCompanyLongTermRatingList : _getCompanyLongTermRatingList,
			getCompanyShortTermRatingList : _getCompanyShortTermRatingList,
			getCompanySecurityDetailList : _getCompanySecurityDetailList,
			getCompanyBenchMarksList : _getCompanyBenchMarksList,
			getMiscInfoCompanyList : _getMiscInfoCompanyList,
			getCompanyKeyParameterDetails : _getCompanyKeyParameterDetails,
			getCapitalMarketInformation : _getCapitalMarketInformation,
			getMGTShareHoldingData : _getMGTShareHoldingData,
			getRatingSummary : _getRatingSummary,
			showDocumentOfPDFOrHTML : _showDocumentOfPDFOrHTML,
			getSmeCompanyDetails : _getSmeCompanyDetails,
			getCompanyPeerComparisonMoreData : _getCompanyPeerComparisonMoreData,
			getPeerSuggesionsList : _getPeerSuggesionsList,
			saveRecentlyViewedCompanyForCompanyProfileModule : _saveRecentlyViewedCompanyForCompanyProfileModule,
			getCompaniesListByNameForPeerComparison : _getCompaniesListByNameForPeerComparison,
			getPeerFixedIncomeData : _getPeerFixedIncomeData,
			getBoardOfDirector : _getBoardOfDirector,
			getPortFolioNames : _getPortFolioNames,
			getNoOfCompanies : _getNoOfCompanies,
			displayingPeerData : _displayingPeerData,
			downloadCompanyProfileScorecardExcel : _downloadCompanyProfileScorecardExcel,
			getExportScorecardPdf : _getExportScorecardPdf,
			getIndustryMedian : _getIndustryMedian,
			getMappedIndicesForCompany : _getMappedIndicesForCompany,
			getRecentUploadedFinancialCompanies : _getRecentUploadedFinancialCompanies,
			getExistingPortFoliosDetailsByUser : _getExistingPortFoliosDetailsByUser,
			addCompanyInExistingPortfolio : _addCompanyInExistingPortfolio,
			getRecentlyViewAndMostView : _getRecentlyViewAndMostView,
			getBseSharePriceData : _getBseSharePriceData,
			getCompanyFixedIncomeData : _getCompanyFixedIncomeData,
			getPeerRatingData : _getPeerRatingData,
			getPeerFinancialInformation : _getPeerFinancialInformation,
			getPeerSharePricedata : _getPeerSharePricedata,
			getPeerKeyParamData : _getPeerKeyParamData,
			getAllRatingAgency : _getAllRatingAgency,
			getPeerKeyIndicator : _getPeerKeyIndicator,
			getPortFoliosCompDetailsByUser : _getPortFoliosCompDetailsByUser,
			getKeyMoreParamData : _getKeyMoreParamData,
			getIndustryBenchmarkFinancialDetails : _getIndustryBenchmarkFinancialDetails,
			getCompanyScorecardDataList : _getCompanyScoreCardDataList,
			getPeerData : _getPeerData,
			getPeerInfoData : _getPeerInfoData,
			getCompanyChargeIndexData : _getCompanyChargeIndexData,
			getBulkBlockDealList: _getBulkBlockDealList,
			getDetailedShareHoldingData:_getDetailedShareHoldingData,
			getReportedFinancialsDetails:_getReportedFinancialsDetails,
			getDirectorPromoterByNameList:_getDirectorPromoterByNameList,
			getBusinessActivityDetails:_getBusinessActivityDetails,
			getCorporateAction : _getCorporateAction,
			getNews : _getNews,
			getCibilCase : _getCibilCase,
			getcorporateaccounment : _getcorporateaccounment,
			getcorporateaccounmentdatelist : _getcorporateaccounmentdatelist,
			getExternalCommercialBorrowing : _getExternalCommercialBorrowing,
			getOverseasDirectInvestment : _getOverseasDirectInvestment,
			getEpfo:_getEpfo,
			getGst:_getGst,
			getPeriodGst :_getPeriodGst,
			getComitteeMeetingData:_getComitteeMeetingData,
            getBoardAttendanceData:_getBoardAttendanceData,
            getBoardMeetingData:_getBoardMeetingData,
            getComitteeMeetingPreviousData:_getComitteeMeetingPreviousData,
            getBoardAttendancePreviousData:_getBoardAttendancePreviousData,
            getBoardMeetingPreviousData:_getBoardMeetingPreviousData,
            getManagementDisclosureData:_getManagementDisclosureData,
            getManagementDisclosurePreviousData:_getManagementDisclosurePreviousData,
            getRegulatoryDisclosure:_getRegulatoryDisclosure,
			getCompoundingDisclosure :_getCompoundingDisclosure,
            getRegulatoryDisclosurePreviousData:_getRegulatoryDisclosurePreviousData,
			getCompoundingDisclosurePreviousData :_getCompoundingDisclosurePreviousData,
            getUboData:_getUboData,
			getAlertData:_getAlertData,
			getBusinessActivityDetails:_getBusinessActivityDetails,
			getComitteeMeetingData:_getComitteeMeetingData,
			getBoardAttendanceData:_getBoardAttendanceData,
			getBoardMeetingData:_getBoardMeetingData,
			getComitteeMeetingPreviousData:_getComitteeMeetingPreviousData,
			getBoardAttendancePreviousData:_getBoardAttendancePreviousData,
			getBoardMeetingPreviousData:_getBoardMeetingPreviousData
			
		};

	}
})();
